import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
    name: 'mentionParser',
    standalone: true
})
export class MentionParserPipe implements PipeTransform {
    constructor(private sanitizer: DomSanitizer) {}

    transform(value: string): SafeHtml {
        if (!value) return '';

        // XSS protection
        let escaped = value
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#039;");

        const mentionRegex = /\[(@[^\]]+)\]\(mention:(\d+)\)/g;
        const htmlOutput = escaped.replace(mentionRegex, (_, name, id) => {
            return `<span class="mention-tag" id="${id}">${name}</span>`;
        });

        return this.sanitizer.bypassSecurityTrustHtml(htmlOutput);
    }
}
